import Axios from 'axios'
import { notification } from 'antd'
import i18next from 'i18next'
import persistStore from '@/store/persistStore'
import appConfig from '@/config'

let authMsgShow = false

const filteredUrls = ['/v1/traces/env', '/v1/traces']

const redirect = () => {
  const isMicro = !!(window as any).__MICRO_APP_ENVIRONMENT__
  if (isMicro) {
    ;(window as any).microApp?.dispatch({ reLogin: true })
  } else {
    const { setState } = persistStore
    if (!authMsgShow) {
      authMsgShow = true
      notification.error({
        description: i18next.t('ikg.loginAgain'),
        message: i18next.t('ikg.error'),
      })
    }
    setTimeout(() => {
      authMsgShow = false
      setState({ token: '' })
      window.location.href = '/login'
    }, 500)
  }
}

function dealParams(
  params: { __proto__: { toString: () => string } },
  isbool?: boolean
) {
  if (!params) return null
  // eslint-disable-next-line no-proto
  if (params.__proto__.toString() === '[object FormData]') return params
  if (Array.isArray(params)) return params
  const copyParams: any = { ...params }
  Object.keys(copyParams).forEach((v) => {
    if (typeof copyParams[v] === 'string') {
      copyParams[v] = copyParams[v].trim()
    }
  })
  return copyParams
}

const micoData = (window as any).microApp?.getData()
// 创建 axios 实例
const request = Axios.create({
  baseURL: micoData?.baseUrl ? micoData.baseUrl + '/api' : '/api',
  // baseURL: 'http://192.168.1.228:7076/api',
  // timeout: 60000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error: any) => {
  if (error.response) {
    const data = error.response.data
    if (error.response.status === 403) {
      notification.error({
        message: i18next.t('ikg.noAuth'),
      })
    }
    const ignore: string | any[] = []
    if (ignore.includes(error.config.url)) return Promise.reject(error)
    if (error.response.status === 401) {
      redirect()
    }
    if (error.response.status === 404) {
      notification.error({
        message: error.message,
      })
    }
  }
  return Promise.reject(error)
}

request.interceptors.request.use((config) => {
  const storeData: any = persistStore.getState()
  const token = storeData.token
  config.headers['token'] = token

  const { product } = appConfig
  config.headers['product'] = product
  config.headers['module'] = product

  const isMicro = !!(window as any).__MICRO_APP_ENVIRONMENT__
  if (isMicro) {
    config.headers['from'] = 'iLink'
  }

  if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json'
  }
  if (config.data) {
    config.data = dealParams(config.data)
  } else if (config.params) {
    config.params = dealParams(config.params)
  }
  return config
}, errorHandler)

request.interceptors.response.use((response) => {
  return new Promise((resolve, reject) => {
    let { data, config } = response
    // 判断文件流类型
    if (data instanceof Blob) {
      return resolve(data as any)
    }
    if (data.code === 200) {
      return resolve(data.data)
    }
    if (data.code === 401) {
      redirect()
      return resolve(data)
    }
    if (data.code === 300) {
      return resolve(data)
    }
    switch (data.status) {
      default: {
        if (!filteredUrls.includes(config?.url as string)) {
          notification.error({
            message: i18next.t('ikg.error'),
            description: data.message,
          })
        }

        reject(data)
      }
    }
  })
}, errorHandler)

export default request

const defaultHeaders = { 'Content-Type': 'application/x-www-form-urlencoded' }
export function httpGet(...args: any[]) {
  const { url, data, headers = {}, responseType, isOriginal = false, signal } = args[0]
  const next: any = {
    url: url,
    method: 'get',
    params: dealParams(data),
    headers: headers,
    responseType,
    isOriginal,
    signal,
  }
  return request(next)
}
export function httpPost(...args: any[]) {
  const {
    url,
    data,
    headers = defaultHeaders,
    responseType,
    isOriginal = false,
    signal,
  } = args[0]
  const next: any = {
    url: url,
    method: 'post',
    data: dealParams(
      data,
      !headers['Content-Type'].includes('application/json')
    ),
    headers: headers,
    responseType,
    isOriginal,
    signal,
  }
  return request(next)
}

export function httpPut(...args: any[]) {
  const {
    url,
    data,
    headers = defaultHeaders,
    responseType,
    isOriginal = false,
    signal,
  } = args[0]
  const next: any = {
    url: url,
    method: 'put',
    data: dealParams(
      data,
      !headers['Content-Type'].includes('application/json')
    ),
    headers: headers,
    responseType,
    isOriginal,
    signal,
  }
  return request(next)
}

export function httpDelete(...args: any[]) {
  const {
    url,
    data,
    headers = defaultHeaders,
    responseType,
    isOriginal = false,
    signal,
  } = args[0]
  const next: any = {
    url: url,
    method: 'delete',
    data: dealParams(
      data,
      !headers['Content-Type'].includes('application/json')
    ),
    headers: headers,
    responseType,
    isOriginal,
    signal,
  }
  return request(next)
}
